import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class ProjectModel extends ModelBase<ProjectModel, IProjectDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = ProjectModel.DEFAULT_ID;

    @observable
    public displayName: string = ProjectModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = ProjectModel.DEFAULT_ID;
        this.displayName = ProjectModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: IProjectDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: IProjectDTO[]): ProjectModel[] {
        const types: ProjectModel[] = [];

        for (const dto of dtos) {
            const model = new ProjectModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface IProjectDTO {
    id: string;
    displayName: string;
}
